/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const log = {
  path: '/log',
  component: Layout,
  redirect: '/log',
  name: 'Log',
  meta: {
    title: 'log',
    icon: 'zijinrizhi',
    perm: 'cSiteLogManager'
  },
  children: [
    {
      path: 'system-operation-log',
      component: () => import('@/views/log/system-operation-log/index.vue'),
      name: 'SystemOperationLog',
      meta: {
        title: 'systemOperationLog',
        perm: 'frontSiteOperateLogListByProject'
      }
    },
    {
      path: 'protocol-reporting-log',
      component: () => import('@/views/log/protocol-reporting-log/index.vue'),
      name: 'ProtocolReportingLog',
      meta: {
        title: 'protocolReportingLog',
        perm: 'frontTenementAgreementUploadLogPageListByProject'
      }
    },
    {
      path: 'comparison-log',
      component: () => import('@/views/log/comparison-log/index.vue'),
      name: 'ComparisonLog',
      meta: {
        title: 'comparisonLog',
        perm: 'frontFcLogGetFcComparerLogPageList'
      }
    }
  ]
}
export default log
